<script lang="ts">
    // Invite to the Xert 2.0 Beta Program, shown on load by /my-fitness?beta=true.
    // "Join" adds the user id to the xert2Beta feature tag; "Cancel" just closes.
    import * as Dialog from "$lib/components/ui/dialog/index.js";
    import Button from "@/lib/components/ui/button/button.svelte";
    import { baseRequest } from "@/Util/utils";
    import route from "@/Util/routes";

    let open = true
    let joining = false

    async function join() {
        joining = true
        try {
            const response = await window.fetch(route('UserController@postJoinXert2Beta'), {
                ...baseRequest(),
                method: "POST",
            })
            const data = await response.json()
            if (!data?.success) throw new Error("join failed")
            open = false
            Xert.success("Welcome to the Xert 2.0 Beta Program!")
        } catch (e) {
            Xert.warning("Could not join the Xert 2.0 Beta Program. Please try again later.")
        } finally {
            joining = false
        }
    }
</script>

<!--
    z-[60] on both overlay and content: the newsfeed dialog portals into the same
    #shadcn-ui-dialog-target at z-50, so this has to outrank it to sit on top when both are open.
-->
<Dialog.Root preventScroll portal="#shadcn-ui-dialog-target" bind:open>
    <Dialog.Content class="z-[60] max-w-md" overlayClass="z-[60]">
        <Dialog.Header>
            <Dialog.Title>Join the Xert 2.0 Beta Program?</Dialog.Title>
            <Dialog.Description>
                Xert 2.0 is our next-generation training platform. Joining the beta program turns on
                the new features for your account.
            </Dialog.Description>
        </Dialog.Header>
        <Dialog.Footer>
            <Button variant="outline" on:click={() => (open = false)}>Cancel</Button>
            <Button on:click={join} disabled={joining}>Yes, join the beta</Button>
        </Dialog.Footer>
    </Dialog.Content>
</Dialog.Root>
